// Access the form
var form = document.getElementById('order-tracking');

// Add event listener
form.addEventListener('submit', function (e) {
  e.preventDefault(); // Prevent the form from submitting normally

  // Access the input element
  var trackingField = form.elements['tracking'];

  // Extract the tracking number
  var trackingNumber = trackingField.value;

  // Construct the URL
  var url = 'https://stallionexpress.ca/track/?tracking=' + encodeURIComponent(trackingNumber);

  // Redirect the user to the URL
  window.location.href = url;
});
